module.exports = __webpack_public_path__ + "img/gebackenebananeohnehintergrund.39a66868.png";